module.exports = __webpack_public_path__ + "img/grab.45c45b47.png";